"use client";

/**
 * Dark mode toggle. Reads/writes localStorage.theme ('light' | 'dark') and toggles .dark on <html>.
 */
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  function syncFromDom() {
    setIsDark(document.documentElement.classList.contains("dark"));
  }

  useEffect(() => {
    syncFromDom();
    window.addEventListener("theme-change", syncFromDom);
    return () => window.removeEventListener("theme-change", syncFromDom);
  }, []);

  function toggle() {
    const html = document.documentElement;
    const next = html.classList.contains("dark") ? "light" : "dark";
    if (next === "dark") {
      html.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setIsDark(true);
    } else {
      html.classList.remove("dark");
      localStorage.setItem("theme", "light");
      setIsDark(false);
    }
    window.dispatchEvent(new CustomEvent("theme-change", { detail: next }));
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="rounded-md p-2 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
